// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientUpSearchResultModel {
    static getAttributeTypeMap() {
        return PatientUpSearchResultModel.attributeTypeMap;
    }
}
PatientUpSearchResultModel.discriminator = undefined;
PatientUpSearchResultModel.additionalProperties = false;
PatientUpSearchResultModel.attributeTypeMap = [
    {
        "name": "securePartyId",
        "baseName": "securePartyId",
        "type": "string"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=patientUpSearchResultModel.js.map